export const Breakpoints = {
	MOBILE: '525px',
	TABLET: '768px',
	LAPTOP: '1024px',
};
